<template>
  <div
    v-loading="loading"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <div style="background-color: #fff; padding: 15px; box-sizing: border-box">
      <el-row :gutter="10" style="margin-bottom: 20px; min-height: 114px">
        <el-col :span="4" v-for="(item, index) in typeList" :key="index">
          <div
            class="box fontCenter"
            :class="{ 'box-color': index == activeName }"
            @click="clickHandle(index, item.name)"
            style="flex-direction: column"
          >
            <div class="type">{{ item.name }}</div>
            <div class="numberBorder">
              <span style="font-size: 30px; color: #81d3f8; line-height: 35px">{{
                item.num ? item.num : 0
              }}</span>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-tabs v-model="activeTab" type="border-card">
        <!-- tab -->
        <el-tab-pane :label="orderName" name="1">
          <baseTable :key="orderName" :orderName="orderName"></baseTable>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
  import API from '@/api/homepage/overdueReminder.js';
  import baseTable from './components/baseTable.vue';
  // import XEUtils from 'xe-utils/methods/xe-utils';
  import { formatDate } from '@/utils';
  export default {
    name: 'overdueReminder',
    data() {
      return {
        activeName: 0,
        orderName: '',
        activeTab: '1',
        loading: false,
        typeList: {},
      };
    },
    mounted() {
      this.activeName = 0;
      this.getOrderTypeName();
    },
    methods: {
      clickHandle(activeName, orderName) {
        if (this.orderName == orderName) {
          return;
        }
        this.activeName = activeName;
        this.orderName = orderName;
        console.log('点击单据类型', activeName, orderName);
      },
      // 根据业务板块获取单据类型
      async getOrderTypeName() {
        const remindDate = formatDate(new Date(), true);
        const postData = {
          // companyCode: this.userInfo.companyCode,
          // departmentCode: this.userInfo.departmentCode,
          // companyName: this.userInfo.companyName,
          businessGroup: this.userInfo.businessGroup,
          departmentCodeList: this.userInfo.allDepartmentList.map((v) => v.personDepartmentCode),
          remindDate: remindDate,
          pageSize: 10,
          pageNum: 1,
          adminFlag: '2',
        };
        this.loading = true;
        let { data } = await this.$axios.post(API.OVERDUE_REMINDER_TAG, postData);
        this.loading = false;
        if (data.code == 0) {
          let type = data.data;
          let typeList = [];
          // for (let key in type) {
          //   typeList.push(type[key]);
          // }
          typeList[0] = type.awaitingDispatch;
          typeList[1] = type.pendingPayment;
          typeList[2] = type.incompletePayment;
          typeList[3] = type.pendingPayableSettlement;
          typeList[4] = type.pendingCollectInvoice;
          typeList[5] = type.pendingPickup;
          typeList[6] = type.pendingReceiptSettlement;
          typeList[7] = type.pendingInvoice;
          typeList[8] = type.pendingReceiptPayment;

          this.typeList = typeList;
          this.orderName = this.typeList[0]?.name;
          // this.getTableData();
          console.log('单据类型', this.typeList, data);
        } else {
          this.cancel();
          this.$message.error('单据类型获取失败');
        }
      },
    },
    watch: {},
    components: {
      baseTable,
    },
  };
</script>
<style lang="scss" scoped>
  .type {
    font-size: 16px;
    text-align: center;
    color: rgb(129, 211, 248);
    height: 30px;
    padding: 5px 0px;
  }

  .box {
    background-color: #ebf3fe;
    margin: 4px 0 10px 0;
    border-radius: 5px;
  }
  .box-color {
    background-color: #cdd9e6;
  }
  .numberBorder {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 5px;
    flex-direction: column;
    font-size: 12px;
    padding: 10px 0px;
    border-top: 1px solid #ddd;
  }
  .box-color {
    .numberBorder {
      border: 1px solid #fff;
      border-left: 0;
      border-bottom: 0;
    }
  }
</style>
